import {
  ISocialConnection,
  SocialConnection,
} from '@app/models/SocialConnection'
import { ISocialNetwork } from '@app/models/SocialNetwork'
import { bindFunctions } from '@app/utils/class'
import { IconName, IconPrefix } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as React from 'react'

import { Input } from 'reactstrap'

import './SocialConnection.scss'

export interface ISocialConnectionUIProps {
  className?: string
  onChange: (e: ISocialConnection) => any
  socialConnection: ISocialNetwork
  style?: React.CSSProperties
  userName?: string
}

export interface ISocialConnectionStateProps {
  socialNetwork?: ISocialNetwork
}

interface IComponentState {
  username: string
}

type SocialConnectionProps = ISocialConnectionUIProps &
  ISocialConnectionStateProps

export class SocialConnectionEditor extends React.PureComponent<
  SocialConnectionProps,
  IComponentState
> {
  public constructor(props: any) {
    super(props)

    this.state = {
      username: this.props.userName || '',
    }

    bindFunctions(this)
  }

  public render() {
    const socialIcon = this._generateSocialIcon(
      this.props.socialConnection.name,
    )

    return (
      <div className={this.props.className} style={this.props.style}>
        <FontAwesomeIcon
          style={{ fontSize: '2rem' }}
          className={`social-connection ${this.props.socialConnection.name.toLowerCase()}`}
          icon={socialIcon}
          fixedWidth
        />
        <Input
          placeholder='ex: joe1234'
          value={this.state.username}
          onChange={(e) => this._editUsername(e, this.props.socialConnection)}
        />
      </div>
    )
  }

  private _editUsername(
    event: React.ChangeEvent<HTMLInputElement>,
    socialConnection: ISocialNetwork,
  ) {
    this.props.onChange(
      SocialConnection.fromJS({
        type: socialConnection.id,
        username: event.target.value,
      }),
    )

    this.setState({
      username: event.target.value,
    })
  }

  private _generateSocialIcon(name: string) {
    let socialIcon: [IconPrefix, IconName] = ['fab', 'facebook']

    if (name.toLowerCase() === 'linkedin') {
      socialIcon = ['fab', 'linkedin']
    } else if (name.toLowerCase() === 'twitter') {
      socialIcon = ['fab', 'twitter']
    } else if (name.toLowerCase() === 'instagram') {
      socialIcon = ['fab', 'instagram']
    }

    return socialIcon
  }
}
